/**
 * Re-exports loglevel with noConflict
 */

 /** this comment exists as a typedoc workaround */
import * as Log from 'loglevel';

export default Log.noConflict();
